<template>
  <div class="page" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="注册" class="user_service_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #ff5000; color:#FFFFFF;'"></van-nav-bar>

    <!-- 输入手机号，调起手机号键盘 -->
    <van-field v-model="phone" type="tel" label="手机号" placeholder="请输入手机号" />
    <van-field v-model="code" center clearable label="短信验证码" placeholder="请输入短信验证码">
      <template #button>
        <van-button v-if="time == 0" size="small" type="primary" color="#ff5000" plain hairline @click="codeClick">获取验证码</van-button>
        <van-button v-if="time > 0" size="small" type="primary" color="#CCCCCC" plain hairline>{{ time }}s</van-button>
      </template>
    </van-field>
    <van-field v-model="password" type="password" label="密码" placeholder="请输入密码" />
    <van-field v-model="towPassword" type="password" label="二次密码" placeholder="请再次输入密码" />

    <!-- 按钮 -->
    <van-button class="foot-btn" type="primary" color="#ff5000" block @click="login">注册</van-button>

    <!-- 按钮 -->
    <p class="go-page">温馨提醒:</p>
    <p class="go-page">1、一个手机号只能作为一个账号的登录名:</p>
    <!-- <p class="go-page">2、手机号修改成功，原手机号将不支持登录。</p> -->

  </div>
</template> 

<script>
export default {
  name: "new-bind",
  components: {},
  props: {},
  data() {
    return {
      checked: false,
      time: 0,
      currentTime: 60,
      phone: "", //手机号码
      isPhone: false,
      code: "", //短信验证码
      password: "", // 密码
      towPassword: "", // 2密码
      // openid: Lockr.get("openId") ,

      // source_type:来源：默认0
      // openid:微信openid
      // invite_code:邀请码
    };
  },
  watch: {
    phone(newValue, oldValue) {
      if (!/^1[3456789]\d{9}$/.test(newValue)) {
        this.isPhone = false;
      } else {
        this.isPhone = true;
      }
    },
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {},
  methods: {
    login() {
      var that = this;

      var invite_code =
        Lockr.get("invite_code"); //邀请码
      if (!/^1[3456789]\d{9}$/.test(that.phone)) {
        this.$toast.fail("请填写正确的手机号！");
        return;
      }
      if (!that.code) {
        this.$toast.fail("验证码有误，请重新填写！");
        return;
      }
      if (!that.password) {
        this.$toast.fail("密码有误，请重新填写！");
        return;
      }
      if (!that.towPassword) {
        this.$toast.fail("密码有误，请重新填写！");
        return;
      }
      if (that.password != that.towPassword) {
        this.$toast.fail("两次密码不一致，请重新填写！");
        return;
      }

      // if (!that.checked) {
      //   this.$toast.fail("请选择已阅读并同意服务条款！");
      //   return;
      // }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let data = {
        phone: that.phone, // 手机号码
        code: that.code, // 短信验证码
        password: that.password, // 密码
        source_type: 0,
        openid: Lockr.get("openId"), //微信openid
        invite_code: invite_code, //邀请码, 
      };
      console.log(data)
      this.$post("/api/register", data, data).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 0) {
          this.$toast.clear(); //关闭弹窗
          that.$toast({ message: "注册成功~" });
          that.getUserInfo(-1);
        } else {
          that.$toast.fail(res.data.message);
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 条款
    // goClause() {
    //   this.$router.push({
    //     name: "zdyx-clause",
    //     query: {
    //       id: "",
    //     },
    //   });
    // },
    codeClick() {
      var that = this;
      var currentTime = that.currentTime;

      if (!/^1[3456789]\d{9}$/.test(that.phone)) {
        this.$toast.fail("请填写正确的手机号！");
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let data = {
        type: 4,
        phone: that.phone,
      };
      this.$post("/api/SendCode", data, data).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast.clear(); //关闭弹窗
          this.$toast({
            message: "已发送验证码~",
          });

          that.time = currentTime;
          let interval = setInterval(function () {
            that.time = currentTime - 1;
            currentTime--;
            if (currentTime <= 0) {
              clearInterval(interval);
              that.time = 0;
              that.currentTime = 60;
            }
          }, 1000);
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.user_service_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  text-align: left;
  background-color: #f7f7f7;
  h3 {
    text-align: left;
    margin-top: 70px;
    padding-left: 30px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 61px;
    color: #2a2e43;
  }
  .top-tips {
    text-align: left;
    padding-left: 38px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30px;
    color: #999999;
  }
  .centers {
    margin-top: 50px;
    padding: 0 38px;
    .input-tips {
      margin-top: 10px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      text-align: left;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .input-success {
        display: inline-block;
        width: 18px;
        height: 18px;
        font-size: 18px;
        color: #ff5000;
      }
    }
    .code-input {
      // margin: 100px 0;
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      border-bottom: solid 1px #cccccc;
      display: flex;
      justify-content: space-between;
      input {
        width: 70%;
        height: 100%;
        text-align: left;
        background: none;
        outline: none;
        border: none;
        font-size: 18px;
      }
      .code-btn {
        width: 80px;
        height: 25px;
        border: 1px solid #999999;
        opacity: 1;
        border-radius: 5px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 21px;
        color: #999999;
      }

      .arr_icon {
        border: 1px solid #ff5000;
        color: #ff5000;
      }
    }
  }
  .foot-tips {
    margin-top: 40px;
    text-align: left;
    padding-left: 38px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // line-height: 21px;
    color: #999999;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      margin-left: 5px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #1775e6;
    }
  }
  .foot-btn {
    width: 345px;
    height: 44px;
    border-radius: 5px;
    margin: 30px auto;

    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    letter-spacing: 1px;
  }
  .go-page {
    padding: 0 15px;
    text-align: left;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    letter-spacing: 1px;
  }
}
</style>
